<template>
    <div id="videoplatform">
        <Banner
            :title="differentRouter.title"
            :breadcrumbs="differentRouter.breadcrumbs"
            :type="differentRouter.type"
        ></Banner>
        <div class="container">
            <div class="center_title">
                <Title
                    :en="title.en"
                    :chtFirst="title.chtFirst"
                    :chtSecond="title.chtSecond"
                    :center="true"
                ></Title>
            </div>
            <section class="list_box">
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                >
                    <div class="item" v-for="(item,index) in videos" :key="index">
                        <Video :data="item" :isPublic="ispublic"></Video>
                    </div>
                </div>
                <notfound v-if="videos.length == 0" info="目前尚未開放影像衛教，"></notfound>
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Video from "@/components/information/videoCard";
import API from "@/service/conference";
export default {
    name: "videoplatform",
    components: {
        Video
    },
    props: {
        propvideos: {
            type: Object
        },
        isallow: {
            type: Boolean
        },
        ispublic: {
            type: Boolean
        }
    },
    data() {
        return {
            videos: [],
            totalPage: 1,
            nowPage: 1,
            videoId: "",
            busy: false,
            isLoading: false,
            title: {
                en: "",
                chtFirst: "",
                chtSecond: ""
            }
        };
    },
    methods: {
        back() {
            window.history.go(-1);
        },
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (process.env.NODE_ENV === "production") {
                if (vm.totalPage == 1 || vm.totalPage == vm.nowPage) {
                    return false;
                }
                vm.isLoading = true;
                vm.nowPage += 1;
                API.getVideoList({
                    page: vm.nowPage,
                    count: 10,
                    isPublic: vm.ispublic
                }).then(result => {
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                    if (result.Data.Videos.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    let VideosList = result.Data.Videos;
                    vm.videos = vm.videos.concat(VideosList);
                });
            }
        }
    },
    computed: {
        differentRouter() {
            const vm = this;
            if (vm.ispublic) {
                return {
                    title: "民眾衛教專區",
                    breadcrumbs: [
                        {
                            url: "/",
                            title: "首頁"
                        },
                        {
                            title: "民眾衛教專區"
                        },
                        {
                            url: "/HealthEducation/HealthVideos",
                            title: "影像衛教"
                        }
                    ],
                    type: "health"
                };
            } else {
                return {
                    title: "會刊及影音",
                    breadcrumbs: [
                        {
                            url: "/",
                            title: "首頁"
                        },
                        {
                            title: "會刊及影音"
                        },
                        {
                            url: "/Conference/DigitalVideos",
                            title: "影像數位平台"
                        }
                    ],
                    type: "information"
                };
            }
        }
    },
    created() {
        const vm = this;
        if (vm.propvideos) {
            let obj = JSON.parse(vm.propvideos);
            vm.videos = obj.Videos;
            vm.totalPage = Math.ceil(parseInt(obj.Total) / 10);
            if (vm.totalPage == 1) {
                vm.busy = true;
            }
        } else {
            vm.videos = [
                {
                    Id: "cc2baa0a-8954-4c86-8687-0b2d16828a2a",
                    Image: require("@/assets/dev/video.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "健康新知2017-糖尿病視網膜病變上",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                },
                {
                    Id: "234sdfhd",
                    Image: require("@/assets/dev/video2.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "健康新知2017-糖尿病視網膜病變下",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                },
                {
                    Id: "awdasd312",
                    Image: require("@/assets/dev/video3.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "健康新知2017-糖尿病視網膜病變中",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                },
                {
                    Id: "123asd43",
                    Image: require("@/assets/dev/video2.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "高雄發大財-跟著禿子走",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                },
                {
                    Id: "123asd43",
                    Image: require("@/assets/dev/video3.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "蔡皇出征，賴孫不生",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                },
                {
                    Id: "123asd43",
                    Image: require("@/assets/dev/video.png"),
                    Video: "../../static/mp4/video1.mp4",
                    Date: "2019-01-07",
                    Title: "健康新知2017-糖尿病視網膜病變上",
                    Introduction:
                        "提供完整國內外研討會及每年各項學術年會與第會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們。"
                }
            ];
        }
        if (!vm.isallow && !vm.ispublic) {
            vm.$swal({
                type: "warning",
                text: "要成為付費會員才能觀看影片唷!",
                confirmButtonText: "確定"
            }).then(() => {
                location.href = "/";
            });
        }
        if (vm.ispublic) {
            vm.title = {
                en: "Video",
                chtFirst: "影像",
                chtSecond: "衛教"
            };
        } else {
            vm.title = {
                en: "Video digital platform",
                chtFirst: "影像",
                chtSecond: "數位平台"
            };
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#videoplatform .remark {
    margin-bottom: 30px;
    text-align: center;
}
#videoplatform .list_box {
    margin-bottom: 60px;
}
#videoplatform .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
}
#videoplatform .list::after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#videoplatform .list .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 25px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    padding-bottom: 20px;
}
#videoplatform .detail .video_box {
    border: 8px solid #eee;
    padding: 30px 10px;
}
#videoplatform .detail .video_box .date {
    color: #666;
    padding: 10px 20px;
    letter-spacing: 2px;
    font-size: 1.1rem;
}
#videoplatform .detail .video_box .title {
    color: #666;
    font-size: 1.4rem;
    padding: 0 20px 20px;
    letter-spacing: 2px;
    line-height: 1.5;
    border-bottom: 1px solid #aaa;
    margin-bottom: 20px;
}
#videoplatform .detail .video_box .video {
    width: 90%;
    margin: auto;
    padding: 40px 0;
}
#videoplatform .detail .video_box .video video {
    width: 100%;
}
#videoplatform .detail .video_box .remark {
    color: #666;
    letter-spacing: 2px;
    line-height: 1.2;
}
#videoplatform .detail .video_box .download {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    width: 165px;
}
@media screen and (max-width: 992px) {
    #videoplatform .list .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #videoplatform .list .item {
        width: 100%;
        margin: 0 auto 30px;
        max-width: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/videoplatform.vue